import { render, staticRenderFns } from "./useripwhitelist-add-or-update.vue?vue&type=template&id=6f1420b6&"
import script from "./useripwhitelist-add-or-update.vue?vue&type=script&lang=js&"
export * from "./useripwhitelist-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports